import React, { FC } from 'react';
import { RequirementsProps } from '../../../../tools/context';
import { useTranslation } from '../../../../tools/i18n';
import { getFormattedEuro } from '../../../../tools/tools';
import ButtonV2 from '../../../ButtonV2';
import { useTravelPlannerResultsContext } from '../../TravelPlanerResultsContext';

interface PriceBoxProps {
  requirements: RequirementsProps;
}

const getSpotValues = (data: any): any[] => {
  if (!data || typeof data !== 'object') return [];
  return Object.values(data)
    .map((jour: any) => {
      if (Array.isArray(jour)) {
        const nightEntry = jour.find((i: any) => i?.key?.startsWith('night'));
        if (nightEntry && Array.isArray(nightEntry.value) && nightEntry.value.length > 0) {
          return nightEntry.value[0];
        }
      }
      return null;
    })
    .filter(Boolean);
};
const PriceBox: FC<PriceBoxProps> = ({ requirements }) => {
  const { t } = useTranslation();
  const { inputs, formattedData } = useTravelPlannerResultsContext();
  const spots = getSpotValues(formattedData);

  const calculateTripNightCount = (): number | null => {
    const total = spots.reduce((sum, spot) => {
      const night = spot?.nightsPerSpot ? Number(spot.nightsPerSpot) : 0;
      return sum + night;
    }, 0);
    return total > 0 ? total : null;
  };

  const calculateTripPrice = (): number | null => {
    const total = spots.reduce((sum, spot) => {
      const price = spot?.price ? Number(parseFloat(spot.price).toFixed(2)) : 0;
      return Number((sum + price).toFixed(2));
    }, 0);
    return total > 0 ? total : null;
  };

  const tripPrice = calculateTripPrice();
  const tripNightCount = calculateTripNightCount();

  const saveCart = () => {
    const subDomain = requirements.environment === 'prod' ? '' : 'staging.';
    const cartUrl = `https://${subDomain}checkout.bivouacs.huttopia.com/fr-FR/cart-multi`;
    let urlParams = `?equipment=${inputs.travelerProfile.equipment}&adults=${inputs.travelerProfile.adultCount}`;
    inputs.travelerProfile.childrenAges.map((c) => (urlParams += `&children[]=${c}`));
    spots.map((s) => (urlParams += `&site[]=${s.id}&from[]=${s.startDate}&to[]=${s.endDate}`));
    window.location.href = `${cartUrl}${urlParams}`;
  };

  if (!tripPrice || !tripNightCount) return null;

  return (
    <div className="price-box">
      <div className="label">
        <p>{`${tripNightCount} ${t('travelPlaner.priceBox.label')}`}</p>
        <p className="price">{getFormattedEuro(tripPrice)}</p>
      </div>
      <ButtonV2
        key={'travelPlaner.nightDayHeader.basketbutton'}
        text={t('travelPlaner.priceBox.basketbutton')}
        onClick={saveCart}
        className="basketButton"
        trackingKey="add_to_basket_click"
      />
    </div>
  );
};

export default PriceBox;
